module.exports = __webpack_public_path__ + "static/media/搜索关联性最大的实体（英语等）.3f7bf9b9.png";